<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-file-input
                    v-model="items"
                    accept="image/*, .pdf"
                    counter
                    multiple
                    placeholder="Wybierz pliki"
                    prepend-icon="mdi-paperclip"
                    outlined
                    dense
                    :show-size="1000"
                    @change="addAttachment()"
                >
                    <template #selection="{index, text}">
                        <v-chip
                            label
                            small
                            close
                            @click:close="removeAttachment(index)"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                </v-file-input>
                <v-data-table
                    :items="uploadedFiles"
                    name="requestAttachments"
                    hide-default-header
                    hide-default-footer
                    disable-pagination
                    :mobile-breakpoint="0"
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ formatName(item) }}
                                <v-btn
                                    icon
                                    data-sentry-label="Pobierz"
                                    @click="openInNewTab(item)"
                                >
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                                <v-tooltip top :open-delay="tooltipDelay">
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Usuń"
                                            :disabled="!canDelete(item.createdBy)"
                                            v-on="on"
                                            @click="deleteAttachment(item.id)"
                                        >
                                            <v-icon color="pink">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Usuń</span>
                                </v-tooltip>
                                <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                                    - {{ item.createdBy.firstName }} {{ item.createdBy.lastName }} ({{ formatDate(item.createdAt) }})
                                </template>
                                <template v-else>
                                    - {{ item.createdBy.username }} ({{ formatDate(item.createdAt) }})
                                </template>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { apiConfig } from '@/config'
import attachment from '@/mixins/attachment'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'Attachment',
    mixins: [ attachment, tooltipDelay, dateFormatter ],
    props: {
        action: {
            type: String,
            default: null
        },
        request: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            uploadedFiles: [],
            attachmentError: [],
            items: []

        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
    },
    watch: {
        request() {
            this.createUploadedUrls()
        }
    },
    created() {
        this.createUploadedUrls()
    },
    methods: {
        createUploadedUrls() {
            this.uploadedFiles = []
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            this.$store.state.purchases.requests.requestAttachments.forEach(function(item) {
                let file = {
                    id : item.id,
                    file: mediaRoot + item.file,
                    createdBy: item.createdBy,
                    createdAt: item.createdAt
                }

                this.uploadedFiles.push(file)
            }, this)
        },
        deleteAttachment(attachmentId) {
            this.$store.dispatch('purchases/deleteRequestAttachment', attachmentId)
                .then(() => {
                    this.$emit('get-request', this.request.id)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        formatName(value) {
            const attachmentUrl = value.file.split('/')

            return attachmentUrl[attachmentUrl.length - 1]
        },
        openInNewTab(url) {
            window.open(url.file, '_blank').focus()
        },
        canDelete(createdBy) {
            return createdBy.id === this.userId
        },
        removeAttachment(item) {
            this.items.splice(this.items.indexOf(item), 1)
        },
        addAttachment() {
            this.$emit('update-items', this.items)
        }
    }
}
</script>